<div class="container-white-full-column contactUs">
  <div class="row">
    <div class="col-12 mb-4">
      <h1>Contact Us</h1>
    </div>
  </div>

  <!-- Logged In -->
  @if (hasContactUsList) {
    <div class="row">
      @if (loadingContactLists) {
        <div class="col-md-12">
          <app-spinner message='Loading contact numbers…'></app-spinner>
        </div>
      }
      @if (!loadingContactLists) {
        <div class="col-md-7">
          <h4 id="contactUs-content" class="text-center contactUs-email">Email us at: <a appMailTo></a></h4>
        </div>
        <div class="col-md-6">
          @if (contactUsLists) {
            @for (list of contactUsLists.retailContactUsList; track list) {
              <div class="contactUs-phoneList">
                <h2 class="contactUs-phoneList__title">
                  {{list.phoneLine}}
                </h2>
                @if (list.phoneAlias) {
                  <p class="contactUs-phoneList__number" id="phone-number">
                    {{list.phoneAlias}} ({{list.phoneNumber | phoneNumber}})
                  </p>
                }
                @if (!list.phoneAlias) {
                  <p class="contactUs-phoneList__number" id="phone-number-no-alias">{{list.phoneNumber | phoneNumber}}</p>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  }

  <!-- not Logged In -->
  @if (!hasContactUsList) {
    <div class="row">
      <div class="col-12">
        <h4 class="text-center contactUs-email">Email us at: <a appMailTo></a></h4>
      </div>
    </div>
  }
</div>
